import { Trash2Icon } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '../ui/button';

type Props = {
  title?: string;
  description?: string;
  onAction: (confirmed: boolean) => void;
  onClick: () => void;
};

export const ConfirmDeleteAlert = ({
  title = 'Are you absolutely sure?',
  description = 'This action cannot be undone. This will permanently delete this resource.',
  onAction,
  onClick,
}: Props) => {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button variant="outline" onClick={onClick}>
          <Trash2Icon className="text-destructive" size={16} />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => onAction(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => onAction(true)}>Continue</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
